import React from 'react';
import {Navigate, useLocation} from 'react-router-dom';

import {HomeEnum} from 'presentation/constants';
import {FiveStarsDetail} from '../FiveStarsDetail';
import {useGetFiveStarsQuery} from '../../queries/useGetFiveStarsQuery';

export function FiveStarsLayout() {
	const {
		state: {cdAtendimento, tipo},
	} = useLocation();
	const {data} = useGetFiveStarsQuery();

	const ratingDetail =
		data?.items?.find(
			item => item.keys.cdatendimento === cdAtendimento && item.keys.tipo === tipo,
		) ?? null;

	if (!ratingDetail) {
		return <Navigate to={HomeEnum.HOME_PAGE} />;
	}

	return <FiveStarsDetail ratingDetail={ratingDetail} />;
}
